import gql from "graphql-tag";

export const CREATE_ACKNOWLEDGED_BY_USER = gql`
  mutation createAcknowledgedByUser {
    createAcknowledgedByUser
  }
`;
